import { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import authUtils from '../utils/authUtils';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function ProtectedRoute({ children }) {
  const [authState, setAuthState] = useState('loading'); // loading, authenticated, needs_2fa, unauthenticated
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      // First check if we have a token at all
      const token = authUtils.getToken();
      console.log('[ProtectedRoute] Checking auth, token present:', !!token);

      try {
        // The global axios interceptor will add the Authorization header
        const response = await axios.get(`${API}/auth/me`);
        
        console.log('[ProtectedRoute] Auth response:', {
          twofa_verified: response.data.twofa_verified,
          email: response.data.email
        });
        
        // Check if 2FA is verified
        if (!response.data.twofa_verified) {
          setAuthState('needs_2fa');
        } else {
          setAuthState('authenticated');
        }
      } catch (error) {
        console.error('[ProtectedRoute] Auth check failed:', error.response?.status);
        // Clear stored token on auth failure
        authUtils.clearToken();
        setAuthState('unauthenticated');
      }
    };

    checkAuth();
  }, [location.pathname]);

  if (authState === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-700"></div>
      </div>
    );
  }

  if (authState === 'unauthenticated') {
    return <Navigate to="/login" replace />;
  }

  if (authState === 'needs_2fa') {
    return <Navigate to="/verify-otp" replace />;
  }

  return children;
}

export default ProtectedRoute;